import { z } from 'zod';

/** Every build-time variable the admin portal reads (Vite inlines `import.meta.env`). */
const schema = z.object({
  /** Dev: Vite proxies /api → :3000. Production: set it (same site as the portal). */
  VITE_API_BASE_URL: z
    .string()
    .optional()
    .transform((v) => v?.replace(/\/$/, '') ?? '/api'),
});

export const env = schema.parse({
  VITE_API_BASE_URL: import.meta.env.VITE_API_BASE_URL as string | undefined,
});
